import { Cart } from '@/clients/storefront/storefrontClient';

export const getTotalQty = (cart: Cart | null): number => {
  if (!cart) return 0;

  return cart.lines.edges.reduce((acc, edge) => acc + edge.node.quantity, 0);
};
